package app.svg

import dev.fritz2.core.RenderContext

fun RenderContext.arrowDown(className: String) {
    svg(className) {
        attr("xmlns", "http://www.w3.org/2000/svg")
        attr("fill", "none")
        attr("viewBox", "0 0 24 24")
        attr("stroke-width", "1.5")
        attr("stroke", "currentColor")
        path {
            attr("stroke-linecap", "round")
            attr("stroke-linejoin", "round")
            attr("d", "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3")
        }
    }
}
